import { Pipe, PipeTransform } from '@angular/core';


export class ObjKeysPipe implements PipeTransform {
	public transform(value: any, args?: any[]): any[] {
		let keys = [];
		for (let key in value) {
			if (value.hasOwnProperty(key)) {
				keys.push({key, value: value[key]});
			}
		}
		return keys;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/pipes/object-keys.pipe.ts